import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-background-50/80 mb-4 tracking-wide">
                  {section.title}
                </h4>
                <div className="w-8 h-px bg-background-50/20 mb-4"></div>
                <ul className="flex flex-col gap-2.5">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-50/50 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-16 md:mt-20 pt-8 border-t border-background-50/10">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div className="flex items-baseline gap-2">
                <span className="text-4xl md:text-5xl font-heading font-black text-background-50 tracking-tight">
                  爆瓜网
                </span>
                <span className="text-xs text-background-50/40 font-label">— 吃瓜黑料第一入口</span>
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
                <div className="flex items-center gap-4">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer" aria-label="抖音" rel="nofollow">
                    <i className="ri-tiktok-line text-sm"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer" aria-label="B站" rel="nofollow">
                    <i className="ri-bilibili-line text-sm"></i>
                  </a>
                </div>
                <span className="text-xs text-background-50/30 font-label whitespace-nowrap">
                  &copy; 2019 - 2026 爆瓜网 baogua.com
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}